import { Box } from "@chakra-ui/react";
import { Button, Checkpoint, Container, Number } from "components";
import { PressBanner } from "components/molecules/PressBanner";

export const ProductPageMastheadPress = () => {
  return (
    <Box borderBottom="1px solid" borderColor="gray.150">
      <Container>
        <PressBanner />
      </Container>
    </Box>
  );
};
